import { V3_APP_BASE_URL } from '@/constants/Config';

export interface FeatureFlag {
  feature_name: string;
  id: number;
  switch_value: boolean;
}

interface FlagsResponse {
  message: string;
  data: FeatureFlag[];
}

let flagsCache: FeatureFlag[] | null = null;

export async function getData<T>(urlPath: string): Promise<T> {
  try {
    const result = await fetch(`${V3_APP_BASE_URL}${urlPath}`, {
      method: 'GET',
    });
    return await result.json();
  } catch {
    throw new Error(`Error Hitting V3 url: ${urlPath}`);
  }
}

export async function getFlags(): Promise<FeatureFlag[] | null> {
  if (flagsCache) {
    return flagsCache;
  }

  try {
    const result = await getData<FlagsResponse>(`api/v4/global-features-switch`);
    if (result.message === 'success' && result.data && result.data.length > 0) {
      flagsCache = result.data;
      return result.data;
    }
    return null;
  } catch (error) {
    return null;
  }
}

export function clearFlagsCache(): void {
  flagsCache = null;
}

export async function getFeatureFlag(feature: string): Promise<boolean> {
  const flags = await getFlags();
  return flags?.find((flag) => flag.feature_name === feature)?.switch_value ?? false;
}
